import React,{ useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import i18n from 'i18n-js';
import { executeProductBulkAction, ACTION_MAP } from '../../../utils/productBulkActions';
import { expectReceivingLabels } from '../../../utils/receivingLabelRequest';
import { ResetProductsUpdated } from '../../../actions/productAction';
import { useToast } from '../../../commons/Toast';

const useProductBulkActions = () => {
  const dispatch = useDispatch();
  const productsUpdated = useSelector(state => state.product?.productsUpdated);
  const { showToast, toastMessage, showToastMessage, hideToast } = useToast();

  const [confirmModal, setConfirmModal] = useState({
    visible: false,
    action: null,
    params: null,
    message: ''
  });
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    if (productsUpdated) {
      setRefreshKey(prev => prev + 1);
      dispatch(ResetProductsUpdated());
    }
  }, [productsUpdated, dispatch]);

  const executeBulkAction = useCallback(async (actionKey, params) => {
    const result = await executeProductBulkAction(actionKey, params);

    if (result.success) {
      showToastMessage(result.message);
      if (actionKey === 'printReceivingLabels') {
        if (result.data?.url) {
          window.open(result.data.url);
        } else {
          expectReceivingLabels();
        }
      }
    } else {
      showToastMessage(result.message);
    }
  }, [showToastMessage]);

  const handleBulkAction = useCallback((actionData) => {
    const { action, value, selectedIds, allSelected, unselectedIds, searchQuery, filter, is_kit } = actionData;

    const params = {
      selectedProducts: selectedIds ? selectedIds.map(id => ({ id })) : [],
      selectAll: allSelected || false,
      unselectedIds: unselectedIds || [],
      filter: filter || 'active',
      search: searchQuery || '',
      isKit: is_kit ?? -1,
      status: ''
    };

    const actionKey = ACTION_MAP[value];

    if (!actionKey) {
      showToastMessage(i18n.t('productGrid.unknownAction') + `: ${value}`);
      return;
    }

    if (action === 'changeStatus') {
      params.status = value;
    }

    if (value === 'delete') {
      setConfirmModal({
        visible: true,
        action: actionKey,
        params,
        message: i18n.t('productGrid.deleteConfirmMessage')
      });
      return;
    }

    executeBulkAction(actionKey, params);
  }, [executeBulkAction]);

  const handleConfirmAction = useCallback(() => {
    if (confirmModal.action && confirmModal.params) {
      executeBulkAction(confirmModal.action, confirmModal.params);
    }
    setConfirmModal({ visible: false, action: null, params: null, message: '' });
  }, [confirmModal, executeBulkAction]);

  const handleCancelConfirm = useCallback(() => {
    setConfirmModal({ visible: false, action: null, params: null, message: '' });
  }, []);

  return {
    confirmModal,
    refreshKey,
    handleBulkAction,
    handleConfirmAction,
    handleCancelConfirm,
    showToast,
    toastMessage,
    hideToast
  };
};

export default useProductBulkActions;

